/**
 * OpenList 搜索功能 Hook
 */

import { useState, useCallback, useEffect } from "react"
import { searchFilesAction } from "@/lib/actions/openlist-actions"
import type { OpenListFile, OpenListTreeNode } from "@/types/openlist"
import { searchInTree } from "@/lib/utils/openlist-tree-utils"

interface UseOpenListSearchProps {
  subjectId: string
  treeNodes: OpenListTreeNode[]
  onError: (error: string) => void
}

export function useOpenListSearch({ subjectId, treeNodes, onError }: UseOpenListSearchProps) {
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState<OpenListFile[]>([])
  const [isSearching, setIsSearching] = useState(false)

  useEffect(() => {
    if (!searchTerm) {
      handleSearch()
    }
  }, [searchTerm])

  // 搜索文件
  const handleSearch = useCallback(async () => {
    if (!searchTerm.trim()) {
      setSearchResults([])
      return
    }

    setIsSearching(true)
    try {
      const result = await searchFilesAction(subjectId, searchTerm, "/")

      if (result.success && result.data) {
        setSearchResults(result.data.files)
      } else {
        onError(result.error || "搜索失败")
        setSearchResults([])
      }
    } catch (err) {
      onError(err instanceof Error ? err.message : "搜索失败")
      setSearchResults([])
    } finally {
      setIsSearching(false)
    }
  }, [subjectId, searchTerm, onError])

  // 获取过滤后的树节点（用于实时搜索）
  // const filteredTreeNodes = searchTerm ? searchInTree(treeNodes, searchTerm) : treeNodes
  const filteredTreeNodes = treeNodes

  return {
    searchTerm,
    setSearchTerm,
    searchResults,
    isSearching,
    filteredTreeNodes,
    handleSearch,
  }
}
